/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import { useEffect, useMemo } from 'react';

import { createResource, useResource, type RouteResource } from '@atlassian/react-resource-router';
import type { JsmMimEntitlement } from './JsmMimEntitlement.types.tsx';

type CloudId = string;

export const jsmMIMEntitlementResource: RouteResource<JsmMimEntitlement | undefined> =
	createResource<JsmMimEntitlement | undefined>({
		type: 'JSM_MIM_ENTITLEMENT',
		getKey: () => 'JSM_MIM_ENTITLEMENT',
		getDataLoader: () =>
			import(
				/*
			webpackChunkName: "async-resource-jsm-mim-entitlement",
			jiraSpaEntry: "async-resource-jsm-mim-entitlement"
		*/
				'./getData.tsx'
			),
		maxAge: __SERVER__ ? 0 : Number.MAX_SAFE_INTEGER,
		isBrowserOnly: false,
	});

export const useJsmMimEntitlementResource = (cloudId: CloudId | null): JsmMimEntitlement => {
	const { data, loading, error, refresh } = useResource(jsmMIMEntitlementResource);

	useEffect(() => {
		if (!data && !loading && !error) {
			refresh();
		}
	}, [data, loading, refresh, error]);

	return useMemo(() => {
		if (error || loading || !data || !cloudId) {
			return {
				isEntitled: false,
			};
		}

		const { isEntitled } = data;

		return {
			isEntitled,
		};
	}, [data, loading, error, cloudId]);
};
